import { create } from "zustand";

import type { OrderFilters } from "../../../data/query-keys/orders";

interface OrdersUiState {
  filters: OrderFilters;
  selectedOrderId: number | null;
  setFilters: (filters: Partial<OrderFilters>) => void;
  openOrder: (orderId: number) => void;
  closeOrder: () => void;
}

export const useOrdersUiStore = create<OrdersUiState>((set) => ({
  filters: {
    search: "",
    status: "active",
    date: "month",
  },
  selectedOrderId: null,
  setFilters: (filters) =>
    set((state) => ({ filters: { ...state.filters, ...filters } })),
  openOrder: (selectedOrderId) => set({ selectedOrderId }),
  closeOrder: () => set({ selectedOrderId: null }),
}));
